import { render } from "./SocialsPrimaryNav.vue?vue&type=template&id=8e4860da"
import script from "./SocialsPrimaryNav.vue?vue&type=script&lang=js"
export * from "./SocialsPrimaryNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__